/**
 * Client-side logic for coverage checker with address autocomplete.
 *
 * @package     Emb_Coverage_Suite
 * @subpackage  Emb_Coverage_Suite/Public/JS
 * @since       0.1.0
 */

(function ($) {
	/**
	 * Clean a string by trimming whitespace and replacing internal spaces with hyphens.
	 *
	 * @param {string} str - String to clean
	 * @returns {string} Cleaned string
	 */
	function emb_coverage_clean_string(str = '') {
		if (typeof str !== 'string') {
			return '';
		}

		return str.replace(/\s/g, '-');
	}

	/**
	 * Enable or disable submit button.
	 *
	 * @param {boolean} enable - Whether to enable the field
	 */
	function emb_coverage_toggle_submit(enable) {
		const submitButton = jQuery('#js-coverage-submit');

		if (enable) {
			submitButton.prop('disabled', false);
		} else {
			submitButton.prop('disabled', true);
		}
	}

	/**
	 * Enable or disable number field.
	 *
	 * @param {boolean} enable - Whether to enable the field
	 */
	function emb_coverage_toggle_number_field(enable) {
		const numberField = jQuery('#js-coverage-number');

		if (enable) {
			numberField.prop('disabled', false);
		} else {
			numberField.prop('disabled', true);
			numberField.val(''); // Clear address field when disabled
		}
	}

	/**
	 * Enable or disable address field.
	 *
	 * @param {boolean} enable - Whether to enable the field
	 */
	function emb_coverage_toggle_address_field(enable) {
		const addressField = jQuery('#js-coverage-address');

		if (enable) {
			addressField.prop('disabled', false);
		} else {
			addressField.prop('disabled', true);
			addressField.val(''); // Clear address field when disabled
		}
	}

	/**
	 * Disable coverage form submit buttons.
	 */
	function emb_coverage_submit_disabled() {
		jQuery( '#js-coverage-submit' ).prop( "disabled", true );
		jQuery( '#js-coverage-floor-submit' ).prop( "disabled", true );
		jQuery( '#js-coverage-floor-reset' ).prop( "disabled", true );
	}

	/**
	 * Enable submit form button.
	 */
	function emb_coverage_submit_enabled() {
		jQuery( '#js-coverage-submit' ).prop( "disabled", false );
		jQuery( '#js-coverage-floor-submit' ).prop( "disabled", false );
		jQuery( '#js-coverage-floor-reset' ).prop( "disabled", false );
	}

	/**
	 * Hide coverage form and show floor form.
	 */
	function emb_coverage_form_hidden() {
		jQuery('#js-coverage-form').removeClass('hidden').addClass('hidden');
		jQuery('#js-coverage-floor-form').removeClass('hidden');
	}

	/**
	 * Hide floor form and show coverage form.
	 */
	function emb_coverage_form_hidden_floor() {
		jQuery('#js-coverage-form').removeClass('hidden');
		jQuery('#js-coverage-floor-form').removeClass('hidden').addClass('hidden');
	}

	/**
	 * Reset forms and messages.
	 */
	function emb_coverage_reset() {
		jQuery( '#js-coverage-form' ).trigger( "reset" );
		jQuery( '#js-coverage-floor-form' ).trigger( "reset" );
		jQuery( '#js-coverage-message' ).removeClass( 'error success' ).empty();
		jQuery( '.forms__result' ).empty();
		emb_coverage_toggle_submit(false);
		emb_coverage_toggle_number_field(false);
		emb_coverage_toggle_address_field(false);
	}

	/**
	 * Reset floor selector options.
	 */
	function emb_coverage_reset_select() {
		jQuery( '#js-coverage-flat' ).empty().append(
			jQuery( "<option>", { value: -1, text: _emb_coverage_suite_lang.loading } )
		);
	}

	/**
	 * Set the message content and style.
	 *
	 * @param {string} message
	 * @param {string} type
	 */
	function emb_coverage_message(message = '', type = '') {
		const messageContainer = jQuery( '#js-coverage-message' );
		messageContainer.removeClass( 'error success' );

		if (type === 'error') {
			messageContainer.addClass( 'error' );
		} else if (type === 'success') {
			messageContainer.addClass( 'success' );
		}

		messageContainer.empty().append(
			jQuery( "<p>", { text: message } )
		);
		messageContainer.show();

		setTimeout(() => {
			messageContainer.empty().removeClass('error success');
		}, 5000);
	}

	/**
	 * Set the message input icon and style.
	 *
	 * @param {string} type
	 * @param {*} dom
	 */
	function emb_coverage_message_input(type = '', dom = '') {
		dom.removeClass( 'success error info' );
		let iconType;

		switch (type) {
			case 'success':
				iconType = 'icon-general-success';
				dom.addClass( 'success' );
				break;
			case 'error':
				iconType = 'icon-general-fail';
				dom.addClass( 'error' );
				break;
			default:
				iconType = 'icon-general-info-black';
				dom.addClass( 'info' );
				break;
		}

		const icon = jQuery( '<i>', { class: iconType } );
		dom.empty().append( icon );
	}

	/**
	 * Validate security fields.
	 *
	 * @param {*} time
	 * @param {*} nonce
	 * @param {*} security
	 *
	 * @returns {boolean}
	 */
	function emb_coverage_security(time, nonce, security) {
		if (0 === time.val().length) {
			return false;
		}
		if (0 === nonce.val().length) {
			return false;
		}
		if (0 < security.val().length) {
			return false;
		}

		return true;
	}

	/**
	 * Validate input fields.
	 *
	 * @param {*} zip
	 * @param {*} address
	 * @param {*} number
	 */
	function emb_coverage_validate(zip, address, number) {
		let isError = false;

		const domZip = jQuery( '.forms__message[data-field="' + zip.attr( "id" ) + '"]' );
		if (0 === zip.val().length || isNaN( zip.val() )) {
			emb_coverage_message_input( 'error', domZip );
			isError = true;
		} else {
			emb_coverage_message_input( 'success', domZip );
		}

		const domAddress = jQuery( '.forms__message[data-field="' + address.attr( "id" ) + '"]' );
		if (0 === address.val().length) {
			emb_coverage_message_input( 'error', domAddress );
			isError = true;
		} else {
			emb_coverage_message_input( 'success', domAddress );
		}

		const domNumber = jQuery( '.forms__message[data-field="' + number.attr( "id" ) + '"]' );
		if (0 === number.val().length || isNaN( number.val() )) {
			emb_coverage_message_input( 'error', domNumber );
			isError = true;
		} else {
			emb_coverage_message_input( 'success', domNumber );
		}

		return true !== isError;
	}

	/**
	 * Send the floor selection.
	 *
	 * @param {*} flat
	 * @param {*} time
	 * @param {*} nonce
	 * @param {*} floor
	 */
	function emb_coverage_send_floor(flat, time, nonce, floor) {
		const floorData = JSON.parse(flat.val());
		const uri = '/wp-admin/admin-ajax.php?timestamp=' + new Date().getTime();

		jQuery.ajax({
			type: 'POST',
			url: uri,
			data: {
				'action': 'emb_coverage_floor',
				'data': {
					'technical_id': floorData.technical_id,
					'flat': floorData.floor,
					'hand': floorData.hand,
					'stair': floorData.stair,
					'time': time.val(),
					'nonce': nonce.val(),
					'floor': floor.val()
				}
			},
			dataType: 'json',
			crossDomain: true,
			cache: false,
			beforeSend: function () {
				emb_coverage_submit_disabled();
				emb_coverage_message(
					_emb_coverage_suite_lang.waiting
				);
			},
			success: function (data, textStatus, jqXHR) {
				if (200 !== jqXHR.status) {
					emb_coverage_reset();
					emb_coverage_reset_select();
					emb_coverage_submit_enabled();

					return;
				}

				emb_coverage_message( data.message, 'success' );

				setTimeout(function() {
					window.location.reload();
				}, 4000);
			},
			error: function (jqXHR) {
				emb_coverage_reset();
				emb_coverage_reset_select();
				emb_coverage_submit_enabled();

				const response = JSON.parse( jqXHR.responseText );
				emb_coverage_message( response.message, 'error' );

				setTimeout(function() {
					emb_coverage_reset();
				}, 8000);
			}
		});
	}

	/**
	 * Form submission handler for floor selection.
	 */
	function emb_coverage_form_floor() {
		const form = jQuery( '#js-coverage-floor-form' );

		form.on( 'submit', function( e ) {
			e.preventDefault();

			const flat = jQuery( '#js-coverage-flat' );
			const time = jQuery( '#js-coverage-floor-time' );
			const nonce = jQuery( '#js-coverage-floor-nonce' );
			const floor = jQuery( '#js-coverage-floor' );

			if (-1 === parseInt( flat.val() )) {
				emb_coverage_message(
					_emb_coverage_suite_lang.error_input,
					'error'
				);
				return false;
			}

			if (false === emb_coverage_security(time, nonce, floor)) {
				emb_coverage_message(
					_emb_coverage_suite_lang.error_security,
					'error'
				);
				return false;
			}

			emb_coverage_send_floor(flat, time, nonce, floor);
			return true;
		});
	}

	/**
	 * Build the floor selector options.
	 *
	 * @param {*} data
	 * @returns
	 */
	function emb_coverage_builder_floor(data) {
		if (0 === data.length) {
			return;
		}

		const units = data.units;
		if (0 === units.length) {
			return;
		}

		const selector = jQuery( '#js-coverage-flat' );
		selector.empty().append(
			jQuery( "<option>", { value: -1, text: _emb_coverage_suite_lang.selecting } )
		);
		units.forEach(function(unit) {
			const id = unit.id || unit.technical_id;
			const floor = unit.address_description.floor || _emb_coverage_suite_lang.without_number;
			const hand = unit.address_description.hand1 || '';
			const stair = unit.address_description.stair || '';

			// Crear objeto con los datos
			const floorData = {
				technical_id: emb_coverage_clean_string(id),
				floor: floor,
				hand: hand,
				stair: stair
			};

			// Descripción visual para el usuario
			let description = floor;
			if (hand) description += ` ${hand}`;
			if (stair) description += ` ${stair}`;

			selector.append(
				jQuery( "<option>", {
					value: JSON.stringify(floorData),
					text: description
				})
			);
		});
	}

	/**
	 * Handle edit address button click event.
	 */
	function emb_coverage_edit_address() {
		jQuery( '#js-coverage-floor-reset' ).on( 'click', function() {
			emb_coverage_form_hidden_floor();
			emb_coverage_reset();
			emb_coverage_reset_select();
		});
	}

	/**
	 * Send the coverage request.
	 *
	 * @param {*} zip
	 * @param {*} address
	 * @param {*} number
	 * @param {*} time
	 * @param {*} nonce
	 * @param {*} coverage
	 */
	function emb_coverage_send(zip, address, number, time, nonce, coverage) {
		const uri = '/wp-admin/admin-ajax.php?timestamp=' + new Date().getTime();
		jQuery.ajax({
			type: 'POST',
			url: uri,
			data: {
				'action': 'emb_coverage',
				'data': {
					'zip': zip.val(),
					'address': address.val(),
					'number': number.val(),
					'time': time.val(),
					'nonce': nonce.val(),
					'coverage': coverage.val()
				}
			},
			dataType: 'json',
			crossDomain: true,
			cache: false,
			beforeSend: function () {
				emb_coverage_submit_disabled();
				emb_coverage_message(
					_emb_coverage_suite_lang.waiting
				);
			},
			success: function (data, textStatus, jqXHR) {
				if (200 !== jqXHR.status) {
					emb_coverage_reset();
					emb_coverage_reset_select();
					emb_coverage_submit_enabled();

					return;
				}

				emb_coverage_message( data.message, 'success' );

				setTimeout(function() {
					emb_coverage_reset();
					emb_coverage_reset_select();
					emb_coverage_submit_enabled();
					emb_coverage_form_hidden();
					emb_coverage_builder_floor( data.response );
				}, 1000);
			},
			error: function (jqXHR) {
				emb_coverage_submit_enabled();
				emb_coverage_reset();
				emb_coverage_reset_select();

				const response = JSON.parse( jqXHR.responseText );
				emb_coverage_message( response.message, 'error' );

				setTimeout(function() {
					emb_coverage_reset();
				}, 8000);
			}
		});
	}

	/**
	 * Form submission handler for coverage check.
	 */
	function emb_coverage_form() {
		const form = jQuery( '#js-coverage-form' );

		form.on( 'submit', function( e ) {
			e.preventDefault();

			const zip = jQuery( '#js-coverage-zip' );
			const address = jQuery( '#js-coverage-address' );
			const number = jQuery( '#js-coverage-number' );
			const time = jQuery( '#js-coverage-time' );
			const nonce = jQuery( '#js-coverage-nonce' );
			const coverage = jQuery( '#js-coverage' );

			if (false === emb_coverage_validate(zip, address, number)) {
				emb_coverage_message(
					_emb_coverage_suite_lang.error_input,
					'error'
				);
				return false;
			}

			if (false === emb_coverage_security(time, nonce, coverage)) {
				emb_coverage_message(
					_emb_coverage_suite_lang.error_security,
					'error'
				);
				return false;
			}

			emb_coverage_send(zip, address, number, time, nonce, coverage);
			return true;
		});
	}

	/**
	 * Handle modal open and close events.
	 */
	function emb_coverage_modal() {
		document.addEventListener('click', (e) => {
			const target = e.target;

			if (target.closest('.js-modal-open')) {
				document.body.classList.add('modal-general--active');
			}

			if (target.closest('.js-background')) {
				document.body.classList.remove('modal-general--active');
				emb_coverage_reset();
				emb_coverage_reset_select();
				emb_coverage_form_hidden_floor();
			}

			if (target.closest('.js-modal-close')) {
				document.body.classList.remove('modal-general--active');
				emb_coverage_reset();
				emb_coverage_reset_select();
				emb_coverage_form_hidden_floor();
			}
		});
	}

	/**
	 * Check if number is valid (digits).
	 *
	 * @param {string} number - Number to validate
	 * @returns {boolean}
	 */
	function emb_coverage_is_valid_number(number) {
		const cleanNumber = number.trim();
		return cleanNumber.length > 0 && !isNaN(cleanNumber);
	}

	/**
	 * Handle number validation and toggle submit button.
	 *
	 * @param {string} numberValue - Current number value
	 */
	function emb_coverage_handle_number_validation(numberValue) {
		if (emb_coverage_is_valid_number(numberValue)) {
			emb_coverage_toggle_submit(true);
		} else {
			emb_coverage_toggle_submit(false);
		}
	}

	/**
	 * Validate number on keyup and enable/disable submit button.
	 */
	function emb_coverage_validate_number() {
		const numberField = jQuery('#js-coverage-number');

		// Disable submit button initially
		emb_coverage_toggle_submit(false);

		numberField.on('keyup', function() {
			const numberValue = jQuery(this).val();
			emb_coverage_handle_number_validation(numberValue);
		});
	}

	/**
	 * Check if ZIP code is valid (5 digits).
	 *
	 * @param {string} zip - ZIP code to validate
	 * @returns {boolean}
	 */
	function emb_coverage_is_valid_zip(zip) {
		const cleanZip = zip.toString().replace(/[\s-]/g, '');
		const aragonRegex = /^(50|22|44)\d{3}$/;

		return aragonRegex.test(cleanZip);
	}

	/**
	 * Handle ZIP code validation and toggle address field.
	 *
	 * @param {string} zipValue - Current ZIP code value
	 */
	function emb_coverage_handle_zip_validation(zipValue) {
		if (emb_coverage_is_valid_zip(zipValue)) {
			// Valid ZIP code
			emb_coverage_toggle_address_field(true);
		} else {
			// Invalid ZIP code
			emb_coverage_toggle_address_field(false);
			emb_coverage_message( _emb_coverage_suite_lang.no_coverage, 'error' );
		}
	}

	/**
	 * Validate ZIP code on keyup and enable/disable address field.
	 */
	function emb_coverage_validate_zip() {
		const zipField = jQuery('#js-coverage-zip');

		// Disable address field initially
		emb_coverage_toggle_address_field(false);

		zipField.on('keyup', function() {
			const zipValue = jQuery(this).val();
			if (zipValue.length === 5) {
				emb_coverage_handle_zip_validation(zipValue);
			} else {
				emb_coverage_toggle_address_field(false);
			}
		});
	}

	/**
     * Debounce helper to delay execution until user stops typing.
     *
     * @param {Function} fn
     * @param {number} wait
     * @returns {Function}
     */
    function emb_coverage_debounce(fn, wait) {
        let timeoutId;

        return function(...args) {
            const context = this;

            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            timeoutId = setTimeout(function() {
                fn.apply(context, args);
            }, wait);
        };
    }

	/**
	 * Handle address item selection from autocomplete list.
	 */
	function emb_coverage_address_item_select() {
		const autocompleteListField = jQuery('#js-coverage-address-autocomplete');

		jQuery(document).on('click', '.js-coverage-address-item', function() {
			const selectedText = jQuery(this).text();
			jQuery('#js-coverage-address').val(selectedText);
			autocompleteListField.empty().removeClass("active");
		});
	}

	/**
	 * Get new address input with AJAX and provide autocomplete suggestions.
	 */
	function emb_coverage_validate_address() {
		const addressField = jQuery('#js-coverage-address');
		const autocompleteListField = jQuery('#js-coverage-address-autocomplete');
		const numberField = jQuery('#js-coverage-number');

		const debouncedRequest = emb_coverage_debounce(function() {
            const zipValue = jQuery('#js-coverage-zip').val();
            const addressValue = addressField.val();
            const uri = '/wp-admin/admin-ajax.php?timestamp=' + new Date().getTime();

			if (addressValue.length <= 3) {
				autocompleteListField.removeClass("active").empty();
				emb_coverage_toggle_number_field(false);
                return;
            }

            jQuery.ajax({
                type: 'POST',
                url: uri,
                data: {
                    'action': 'emb_coverage_extended',
                    'data': {
                        'zip': zipValue,
                        'address': addressValue,
                    }
                },
                dataType: 'json',
                crossDomain: true,
                cache: false,
				beforeSend: function () {
					autocompleteListField.empty()
						.addClass("active")
						.append(
							`<li>${_emb_coverage_suite_lang.loading_address}</li>`
						);
					emb_coverage_toggle_number_field(false);
				},
                success: function (data, textStatus, jqXHR) {
                    if (200 !== jqXHR.status) {
                        autocompleteListField.empty()
							.addClass("active")
							.append(
								`<li>${_emb_coverage_suite_lang.error_address}</li>`
							);
						return;
                    }

					const streets = data.response.data || [];
					if (streets.length === 0) {
						autocompleteListField.empty()
							.addClass("active")
							.append(
								`<li>${_emb_coverage_suite_lang.error_address}</li>`
							);
						return;
					}

					const options = streets.map(function(street) {
						return `<li class="active js-coverage-address-item">${street.address}</li>`;
					});
					autocompleteListField.empty()
						.addClass("active")
						.append(options);

					emb_coverage_toggle_number_field(true);
                },
                error: function (jqXHR) {
					autocompleteListField.empty()
						.addClass("active")
						.append(
							`<li>${_emb_coverage_suite_lang.error_address}</li>`
						);
					emb_coverage_toggle_number_field(false);
                }
            });
        }, 1000); // 1 seconds debounce

		addressField.on('keyup', function(e) {
			if (e.key === 'Enter') {
				return;
			}

			debouncedRequest();
		});

		addressField.on('keydown', function(e) {
			if (e.key !== 'Enter') {
				return;
			}

			const firstItem = autocompleteListField.find('.js-coverage-address-item').first();
			if (firstItem.length === 0) {
				return;
			}

			e.preventDefault();
			const selectedText = firstItem.text();
			jQuery(this).val(selectedText);
			autocompleteListField.empty().removeClass("active");
			numberField.focus();
		});

		emb_coverage_address_item_select();
	}

	/**
	 * Initialize coverage functionalities.
	 */
	function emb_coverage_init() {
		emb_coverage_form();
		emb_coverage_form_floor();
		emb_coverage_edit_address();
		emb_coverage_modal();
		emb_coverage_validate_zip();
		emb_coverage_validate_address();
		emb_coverage_validate_number();
	}

	$(function() {
        emb_coverage_init();
    });
})(jQuery);
